module.exports = __webpack_public_path__ + "static/media/003.df8839c5.jpg";